module.exports = __webpack_public_path__ + "static/media/coinbase.48b6a360.png";